import { render, staticRenderFns } from "./CompanyProjectsSection.vue?vue&type=template&id=f77e0ff0&scoped=true&"
import script from "./CompanyProjectsSection.vue?vue&type=script&lang=js&"
export * from "./CompanyProjectsSection.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProjectsSection.vue?vue&type=style&index=0&id=f77e0ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77e0ff0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
